export interface ReportOutput {
   type: string;
   name: string;
   id?: number;
}

export class ReportOutput implements ReportOutput {
   constructor( o?: ReportOutput ) {
      this.type = o?.type || 'json';
      this.name = o?.name || '';
      if ( o?.id ) { this.id = o?.id; }
   }
}
